import {LoaderFunctionArgs} from 'react-router-dom';
import {getRootStore} from '../../../app.bootstrap';
import {getAppTracer} from '../../../../app.tracer';
import {RouteName} from '../../../router/route-names';
import {getDashboardStores} from '../dashboard.stores';
import {IEntryStore, EntryStore} from './entry.stores';

const trace = getAppTracer('entry.loader');

export async function entryRouteLoader(args: LoaderFunctionArgs): Promise<IEntryStore> {
    trace.info('Starting');
    const rootStore = getRootStore();

    await rootStore.initRootServicesCompleted;

    const dashboardStores = getDashboardStores();
    if (dashboardStores.dashboardState.roomData?.offline) {
        trace.info('Offline room, redirecting to dashboard main');
        const currentUrl = new URL(args.request.url);
        const redirectParams = Object.fromEntries(currentUrl.searchParams.entries());

        await rootStore.tsReactStateHelper.navigateTo(RouteName.DASHBOARD_MAIN, redirectParams);
    }

    const store = new EntryStore();

    trace.info('Completed successfully');
    return store;
}
